import type { Tag } from '../../common/types/common'
import { toDateString, toISOStringAsUTC } from '../../common/utils/dateTimeUtils'

// Tags can contain multiple app names
// If there are multiple app names, combine them
export const getAppNameFromContentTags = (activeTagFilters: Tag[]) =>
  activeTagFilters
    .filter(({ key }) => key === 'appname')
    .map(({ value }) => value)
    .join(', ')

export const getWindowNameFromContentTags = (activeTagFilters: Tag[]) =>
  activeTagFilters
    .filter(({ key }) => key === 'content-category')
    .map(({ value }) => value)
    .join(', ')

export const getSelectedDateCount = (
  firstDate: string,
  lastDate: string,
  ignoreWeekends = false,
) => {
  const startDate = new Date(firstDate)
  const endDate = new Date(lastDate)
  if (!ignoreWeekends) {
    return Math.round((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)) + 1
  }

  let count = 0
  startDate.setHours(0, 0, 0, 0)
  endDate.setHours(0, 0, 0, 1)

  for (
    let currentDate = new Date(startDate);
    currentDate <= endDate;
    currentDate.setDate(currentDate.getDate() + 1)
  ) {
    const dayOfWeek = currentDate.getDay()
    // 0 = Sunday, 6 = Saturday
    // console.log('checked date', currentDate)
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      count++
    }
  }

  return count
}

export const getWeekdayDateRanges = (firstDate: string, lastDate: string) => {
  const startDate = new Date(firstDate)
  const endDate = new Date(lastDate)
  const ranges: {
    firstDate: string
    firstDateIso: string
    lastDate: string
    lastDateIso: string
  }[] = []

  let currentRangeStart: Date | null = null

  for (
    let currentDate = new Date(startDate);
    currentDate <= endDate;
    currentDate.setDate(currentDate.getDate() + 1)
  ) {
    const dayOfWeek = currentDate.getDay()
    const isWeekday = dayOfWeek !== 0 && dayOfWeek !== 6

    if (isWeekday && !currentRangeStart) {
      // Start of a new weekday range
      currentRangeStart = new Date(currentDate)
    } else if (!isWeekday && currentRangeStart) {
      // End of current weekday range (hit weekend)
      const previousDay = new Date(currentDate)
      previousDay.setDate(previousDay.getDate() - 1)
      ranges.push({
        firstDate: toDateString(currentRangeStart),
        firstDateIso: toISOStringAsUTC(new Date(currentRangeStart.setHours(0, 0, 0, 0))),
        lastDate: toDateString(previousDay),
        lastDateIso: toISOStringAsUTC(new Date(previousDay.setHours(23, 59, 59, 999))),
      })
      currentRangeStart = null
    }
  }

  // Handle case where range ends on a weekday
  if (currentRangeStart) {
    ranges.push({
      firstDate: toDateString(currentRangeStart),
      firstDateIso: toISOStringAsUTC(new Date(currentRangeStart.setHours(0, 0, 0, 0))),
      lastDate: toDateString(endDate),
      lastDateIso: toISOStringAsUTC(new Date(endDate.setHours(23, 59, 59, 999))),
    })
  }

  return ranges
}

